var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { faDownload } from "@fortawesome/pro-regular-svg-icons";
import { faAngleDown, faFilter, faSearch as faSearchSolid, faUndo } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PopoverSelectView, TableView } from "@yodlee/common-components";
import { CalenderConfigs } from "@yodlee/common-components/dist/configurations";
import { PermissionEnums, ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import { AvatarUtils, NotificationUtils, TableUtils } from "@yodlee/common-components/dist/utilities";
import { Button, Checkbox, Col, Divider, Dropdown, Icon, Input, Menu, message, Modal, Row, Spin, Tooltip, Typography } from "antd";
import { saveAs } from "file-saver";
import { Parser } from "json2csv";
import { cloneDeep, difference, get, set } from "lodash";
import moment from "moment";
import React, { createRef } from "react";
import ReactDOM from "react-dom";
import Highlighter from "react-highlight-words";
import MediaQuery from "react-responsive";
import { LabelConfigs } from "../../configurations";
import { AmplitudeEventsUtils, DataUtils } from "../../utilities";
var UserStatusEnums;
(function (UserStatusEnums) {
    UserStatusEnums[UserStatusEnums["ACTIVE"] = 0] = "ACTIVE";
    UserStatusEnums[UserStatusEnums["DELETED"] = 3] = "DELETED";
    UserStatusEnums[UserStatusEnums["SUSPENDED"] = 5] = "SUSPENDED";
    UserStatusEnums[UserStatusEnums["LOCKED"] = 99] = "LOCKED";
})(UserStatusEnums || (UserStatusEnums = {}));
var statusToAction = function (statusId) {
    switch (statusId) {
        case UserStatusEnums.ACTIVE: return "Activate";
        case UserStatusEnums.DELETED: return "Delete";
        case UserStatusEnums.SUSPENDED: return "Suspend";
        default: return "Unknown";
    }
};
moment.updateLocale('en', {
    calendar: CalenderConfigs.MOMENT_CALENDER
});
var defaultPreferences = { preferences: { widgets: [] } };
var CONTAINER_TYPE = "widgets", CONTAINER_ID = "user-list-wdgt", TABLE_ID = "user-list";
var initialPagination = {
    defaultPageSize: 50,
    defaultCurrent: 1,
    pageSizeOptions: ["50", "100", "200"],
    showSizeChanger: true,
    showQuickJumper: true,
    current: 1,
    pageSize: 50
};
var initialFilter = {
    role: [],
    status: [],
    accessedOn: [],
    timezone: [],
    createdOn: [],
    updatedOn: []
};
var UserList = /** @class */ (function (_super) {
    __extends(UserList, _super);
    function UserList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            searchKey: '',
            searchFilterKeys: {},
            userPreferenceData: __assign({}, defaultPreferences),
            tablePreferenceData: undefined,
            savedColumnMap: {},
            pagination: __assign({}, initialPagination),
            previousFilter: __assign({}, initialFilter),
            selectedRowStatus: [],
            isSearchExpanded: false
        };
        _this.searchFilterRefs = {};
        _this.inputGlobalSearchRef = createRef();
        _this.handleSearch = function (selectedKeys, confirm, key) {
            var _a;
            var _b = _this.state, searchFilterKeys = _b.searchFilterKeys, pagination = _b.pagination;
            var newSearchFilterKeys = __assign(__assign({}, searchFilterKeys), (_a = {}, _a[key] = selectedKeys[0], _a));
            _this.getUserData(__assign(__assign({}, pagination), { current: initialPagination.current }), newSearchFilterKeys);
            confirm();
            _this.setState({ searchFilterKeys: newSearchFilterKeys });
            AmplitudeEventsUtils.userListSearch(key, selectedKeys[0]);
        };
        _this.handleReset = function (clearFilters, key) {
            var _a = _this.state, searchFilterKeys = _a.searchFilterKeys, pagination = _a.pagination;
            var newSearchFilterKeys = __assign({}, searchFilterKeys);
            delete newSearchFilterKeys[key];
            _this.getUserData(__assign(__assign({}, pagination), { current: initialPagination.current }), newSearchFilterKeys);
            clearFilters();
            _this.setState({ searchFilterKeys: newSearchFilterKeys });
        };
        _this.onExport = function (columns) {
            var authentication = _this.props.authentication;
            var name = LabelConfigs.USER;
            var hide = message.loading('Preparing file...', 0);
            DataUtils.user(authentication).getAll({ view: "all" }).then(function (users) {
                var data = users.data;
                var dataAsRendered = data.map(function (dataItem, index) {
                    var newData = dataItem;
                    columns.forEach(function (column) {
                        var dataValue = get(dataItem, column.dataIndex, "") || "";
                        var renderedString = "";
                        var renderMethod = column.downloadRender || column.render;
                        if (renderMethod) {
                            var tempElement = document.createElement("span");
                            ReactDOM.render(React.createElement("span", null, renderMethod(dataValue, dataItem, index)), tempElement);
                            renderedString = tempElement.innerText;
                        }
                        else {
                            renderedString = dataValue;
                        }
                        newData = (set(newData, column.dataIndex, renderedString));
                    });
                    return newData;
                });
                var fields = columns.map(function (column) { return ({
                    label: column.title.toString(),
                    value: column.dataIndex
                }); });
                var json2csvParser = new Parser({ fields: fields });
                var csvData = '\uFEFF' + json2csvParser.parse(dataAsRendered);
                saveAs(new Blob([csvData], { type: "text/csv;charset=utf-8" }), "Export ".concat(name ? "(".concat(name, ")") : "", " - ").concat(moment(new Date()).format("Do MMM, YYYY"), ".csv"));
                hide();
            });
            try {
                AmplitudeEventsUtils.userListExport();
            }
            catch (e) {
                console.error(e);
            }
        };
        _this.getUserData = function (pagination, filter) {
            var authentication = _this.props.authentication;
            var currentPagination = _this.state.pagination;
            _this.setState({
                users: undefined
            });
            DataUtils.user(authentication).getAll(__assign(__assign(__assign({}, pagination && {
                pageNumber: pagination.current || pagination.defaultCurrent,
                pageSize: pagination.pageSize || pagination.defaultPageSize
            }), filter), { view: "all", fetchTotalCount: true })).then(function (data) {
                _this.setState({
                    users: data.data,
                    pagination: __assign(__assign({}, currentPagination), { pageSize: data.pageSize, total: data.totalCount, current: pagination ? pagination.current || pagination.defaultCurrent : 1 })
                });
            }).catch(function (error) {
                var _a, _b;
                if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 400 || ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) === 404) {
                    _this.setState({
                        users: []
                    });
                }
            });
        };
        _this.componentDidMount = function () {
            var authentication = _this.props.authentication;
            DataUtils.onload(authentication).get(undefined, false).then(function (onload) {
                _this.setState({ onload: onload });
                DataUtils.permission(authentication).get(onload.user.id).then(function (permissions) { return _this.setState({ permissions: permissions }); });
            });
            var parsedPrefData = undefined;
            DataUtils.preference(authentication).get().then(function (response) {
                var prefResp = response === null || response === void 0 ? void 0 : response.preference;
                try {
                    parsedPrefData = JSON.parse(prefResp || "{}");
                }
                catch (e) { }
            }).finally(function () { _this.mapSavedPreferencesToTable(parsedPrefData || __assign({}, defaultPreferences)); });
            DataUtils.role(authentication).getAll().then(function (roles) { return _this.setState({ roles: roles }); });
        };
        _this.mapSavedPreferencesToTable = function (preferences, filter) {
            var customerFilters = undefined;
            var siteTable = TableUtils.getRequiredTable(cloneDeep(preferences), CONTAINER_TYPE, CONTAINER_ID, TABLE_ID);
            if (siteTable) {
                var columnMap = TableUtils.columnsToMap(siteTable === null || siteTable === void 0 ? void 0 : siteTable.columns);
                customerFilters = columnMap === null || columnMap === void 0 ? void 0 : columnMap.filteredFields;
                _this.setState({
                    savedColumnMap: columnMap === null || columnMap === void 0 ? void 0 : columnMap.columnMap,
                    searchFilterKeys: columnMap === null || columnMap === void 0 ? void 0 : columnMap.filteredFields,
                    userPreferenceData: preferences,
                    tablePreferenceData: siteTable,
                    pagination: __assign(__assign({}, _this.state.pagination), siteTable === null || siteTable === void 0 ? void 0 : siteTable.pagination)
                });
            }
            else {
                _this.setState({ userPreferenceData: preferences, tablePreferenceData: {} });
            }
            _this.getUserData(__assign(__assign({}, initialPagination), siteTable === null || siteTable === void 0 ? void 0 : siteTable.pagination), __assign(__assign({}, customerFilters), filter));
        };
        _this.componentDidUpdate = function (prevProps) {
            var _a = _this.props, authentication = _a.authentication, shouldUpdate = _a.shouldUpdate, didUpdate = _a.didUpdate;
            //if selected brand changes get new issue catalog
            if (prevProps.authentication.selectedBrand !== authentication.selectedBrand) {
                _this.setState({
                    roles: undefined,
                    users: undefined,
                    searchKey: "",
                    isSearchExpanded: false
                });
                DataUtils.role(authentication).getAll().then(function (roles) { return _this.setState({ roles: roles }); });
                _this.getUserData(__assign(__assign({}, _this.state.pagination), { current: initialPagination.current }), _this.state.searchFilterKeys);
            }
            if (prevProps.shouldUpdate !== shouldUpdate && shouldUpdate === true) {
                _this.setState({
                    roles: undefined,
                    users: undefined,
                    searchKey: ""
                });
                DataUtils.role(authentication).getAll().then(function (roles) { return _this.setState({ roles: roles }); });
                _this.getUserData(__assign(__assign({}, _this.state.pagination), { current: initialPagination.current }), _this.state.searchFilterKeys);
                didUpdate();
            }
        };
        _this.onTablePreferenceChanges = function (preferenceUpdates) {
            var _a;
            var existingUserPref = _this.state.userPreferenceData;
            var formattedWidgets = TableUtils.formatTablePreferences(cloneDeep(existingUserPref), preferenceUpdates, CONTAINER_TYPE, CONTAINER_ID, TABLE_ID);
            var currentPreferences = cloneDeep(existingUserPref) || {};
            if (currentPreferences === null || currentPreferences === void 0 ? void 0 : currentPreferences.preferences)
                currentPreferences.preferences[CONTAINER_TYPE] = formattedWidgets;
            else
                currentPreferences.preferences = (_a = {}, _a[CONTAINER_TYPE] = formattedWidgets, _a);
            var updatedColumnsMap = TableUtils.getUpdatedColumnsMap(_this.state.savedColumnMap, preferenceUpdates);
            _this.setState({ savedColumnMap: updatedColumnsMap });
            DataUtils.preference(_this.props.authentication).put(currentPreferences)
                .then(function (response) {
                console.debug("PREFERENCES SAVED!");
            }).catch(function (error) {
                console.error(error);
            });
        };
        _this.updateUsersStatus = function (records, status) {
            var updatedUsers = records.map(function (user) { return ({
                id: user.id,
                status: status
            }); });
            _this.setState({
                users: undefined
            });
            var authentication = _this.props.authentication;
            DataUtils.user(authentication).updateMany(updatedUsers)
                .then(function () { return NotificationUtils.success("Success", "Status updated."); })
                .catch(function (error) { var _a, _b; return NotificationUtils.error("Failed", (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost"); })
                .finally(function () {
                _this.getUserData(__assign(__assign({}, _this.state.pagination), { current: initialPagination.current }), _this.state.searchFilterKeys);
                _this.props.onUserDetailsChange();
            });
        };
        _this.updateUserStatus = function (user, statusId) {
            var authentication = _this.props.authentication;
            var _a = _this.state, users = _a.users, onload = _a.onload;
            var newUsers = users || [];
            //prepare blob for request json
            var newValues = {
                status: onload.userStatus.find(function (status) { return status.id === statusId; })
            };
            DataUtils.user(authentication).update(user.id, newValues)
                .then(function () {
                NotificationUtils.success("Success", "Status updated.");
                var foundIndex = -1;
                newUsers.find(function (userItem, index) {
                    if (userItem.id === user.id) {
                        foundIndex = index;
                        return true;
                    }
                    else
                        return false;
                }).status = newValues.status;
                if (foundIndex > -1 && statusId === UserStatusEnums.DELETED) {
                    newUsers.splice(foundIndex, 1);
                }
                _this.setState({
                    users: newUsers
                });
                _this.props.onUserDetailsChange();
            })
                .catch(function (error) { var _a, _b; return NotificationUtils.warning("failed", (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost"); });
        };
        _this.updateUserRole = function (user, role) {
            var authentication = _this.props.authentication;
            var users = _this.state.users;
            var newUsers = users;
            //prepare blob for request json
            var newValues = {
                role: { id: role.key, name: role.value }
            };
            DataUtils.user(authentication).update(user.id, newValues)
                .then(function () {
                NotificationUtils.success("Success.", "Role updated.");
                newUsers === null || newUsers === void 0 ? void 0 : newUsers.forEach(function (userItem) {
                    if (userItem.id === user.id) {
                        user.role = newValues.role;
                    }
                });
                _this.setState({
                    users: newUsers
                });
                _this.props.onUserDetailsChange();
            })
                .catch(function (error) { var _a, _b; return NotificationUtils.warning("Failed", (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message, "ghost"); });
        };
        _this.searchFilterProps = function (dataIndex, title, key, getValue) {
            if (getValue === void 0) { getValue = function (item) { return (item || "").toString(); }; }
            return ({
                filterDropdown: function (_a) {
                    var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                    return (React.createElement("div", { className: "padding-xs" },
                        React.createElement(Input, { className: "no-margin no-padding", ref: function (node) {
                                _this.searchFilterRefs[key] = node;
                            }, placeholder: "Search by ".concat(title.toLowerCase()), value: selectedKeys[0], onChange: function (e) {
                                var value = e.target.value;
                                setSelectedKeys(value ? [e.target.value] : []);
                                !value && _this.handleReset(clearFilters, key);
                            }, onPressEnter: function () { return _this.handleSearch(selectedKeys, confirm, key); }, style: { width: 188, marginBottom: 8, display: 'block' }, allowClear: true })));
                },
                onClearFilter: function () { return _this.handleReset(function () { }, key); },
                filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearchSolid }); } }),
                onFilter: function (value, record) {
                    var newValue = "";
                    if (dataIndex.length === 0 && getValue) {
                        newValue = getValue(record);
                    }
                    else {
                        newValue = get(record, dataIndex, "");
                        if (getValue) {
                            newValue = getValue(newValue);
                        }
                    }
                    return (newValue
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase()));
                },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () { return _this.searchFilterRefs[key].select(); });
                    }
                },
                render: function (text) {
                    var wordsToHighLight = undefined, currentFilter = _this.state.searchFilterKeys[key];
                    if (currentFilter)
                        wordsToHighLight = Array.isArray(currentFilter) ? currentFilter : [currentFilter];
                    return text && wordsToHighLight ?
                        React.createElement(Highlighter, { highlightStyle: { backgroundColor: 'yellow', padding: 0 }, searchWords: wordsToHighLight, autoEscape: true, textToHighlight: getValue(text) }) :
                        React.createElement(Tooltip, { title: getValue(text) }, getValue(text));
                }
            });
        };
        _this.onFilterAmplitudeEvents = function (filters) {
            var _a, _b, _c, _d, _e, _f;
            if ((_a = filters.role) === null || _a === void 0 ? void 0 : _a.length) {
                difference(filters.role, _this.state.previousFilter.role).length > 0 &&
                    _this.setState({
                        previousFilter: filters
                    }, function () {
                        AmplitudeEventsUtils.userListFilter(LabelConfigs.ROLE, filters.role);
                    });
            }
            if ((_b = filters.status) === null || _b === void 0 ? void 0 : _b.length) {
                difference(filters.status, _this.state.previousFilter.status).length > 0 &&
                    _this.setState({
                        previousFilter: filters
                    }, function () {
                        AmplitudeEventsUtils.userListFilter(LabelConfigs.STATUS, filters.status);
                    });
            }
            if ((_c = filters.accessedOn) === null || _c === void 0 ? void 0 : _c.length) {
                difference(filters.accessedOn, _this.state.previousFilter.accessedOn).length > 0 &&
                    _this.setState({
                        previousFilter: filters
                    }, function () {
                        AmplitudeEventsUtils.userListFilter(LabelConfigs.LAST_LOGIN, {
                            from: moment(filters.accessedOn[0].from).format('MM/DD/YYYY'),
                            to: moment(filters.accessedOn[0].to).format('MM/DD/YYYY')
                        });
                    });
            }
            if ((_d = filters.timezone) === null || _d === void 0 ? void 0 : _d.length) {
                difference(filters.timezone, _this.state.previousFilter.timezone).length > 0 &&
                    _this.setState({
                        previousFilter: filters
                    }, function () {
                        AmplitudeEventsUtils.userListFilter(LabelConfigs.USERS_TIME_ZONE, filters.timezone);
                    });
            }
            if ((_e = filters.createdOn) === null || _e === void 0 ? void 0 : _e.length) {
                difference(filters.createdOn, _this.state.previousFilter.createdOn).length > 0 &&
                    _this.setState({
                        previousFilter: filters
                    }, function () {
                        AmplitudeEventsUtils.userListFilter(LabelConfigs.ACCOUNT_CREATED, {
                            from: moment(filters.createdOn[0].from).format('MM/DD/YYYY'),
                            to: moment(filters.createdOn[0].to).format('MM/DD/YYYY')
                        });
                    });
            }
            if ((_f = filters.updatedOn) === null || _f === void 0 ? void 0 : _f.length) {
                difference(filters.updatedOn, _this.state.previousFilter.updatedOn).length > 0 &&
                    _this.setState({
                        previousFilter: filters
                    }, function () {
                        AmplitudeEventsUtils.userListFilter(LabelConfigs.LAST_MODIFIED, {
                            from: moment(filters.updatedOn[0].from).format('MM/DD/YYYY'),
                            to: moment(filters.updatedOn[0].to).format('MM/DD/YYYY')
                        });
                    });
            }
        };
        _this.onSearch = function (value) {
            _this.getUserData(__assign(__assign({}, _this.state.pagination), { current: 0 }), { name: value });
        };
        _this.render = function () {
            var _a = _this.state, users = _a.users, onload = _a.onload, roles = _a.roles, tablePreferenceData = _a.tablePreferenceData, savedColumnMap = _a.savedColumnMap, pagination = _a.pagination, permissions = _a.permissions, selectedRowStatus = _a.selectedRowStatus, searchFilterKeys = _a.searchFilterKeys, isSearchExpanded = _a.isSearchExpanded;
            var _b = _this.props, filter = _b.filter, extra = _b.extra, prefix = _b.prefix, suffix = _b.suffix, header = _b.header, onView = _b.onView;
            var editUserPermission = false;
            var changeRolePermission = false;
            permissions === null || permissions === void 0 ? void 0 : permissions.forEach(function (permission) {
                if (permission.id === PermissionEnums.USER_MANAGEMENT.EDIT && permission.type === 2) {
                    editUserPermission = true;
                }
                else if (permission.id === PermissionEnums.USER_MANAGEMENT.MANAGE_PERMISSION && permission.type === 2) {
                    changeRolePermission = true;
                }
            });
            changeRolePermission = changeRolePermission && editUserPermission;
            var adminOrSuperAdmin = false;
            if ((onload === null || onload === void 0 ? void 0 : onload.user.role.name) === "Admin" || (onload === null || onload === void 0 ? void 0 : onload.isSuperAdmin)) {
                adminOrSuperAdmin = true;
            }
            var searchBar = function (mode) {
                return React.createElement(Input
                // value={searchKey}
                , { 
                    // value={searchKey}
                    autoFocus: mode === "COMPACT", allowClear: true, onPressEnter: function (e) {
                        _this.onSearch(e.target.value);
                    }, placeholder: "Search by user", onChange: function (e) {
                        // this.setState({ searchKey: e.target.value })
                        if ((e.target.value || "").length === 0) {
                            _this.onSearch(e.target.value);
                        }
                    }, style: { maxWidth: mode === "COMPACT" ? "100%" : "300px" }, ref: function (e) { return _this.inputGlobalSearchRef = e; } });
            };
            var suffixView = function (matches) {
                return React.createElement(React.Fragment, null,
                    React.createElement(React.Fragment, null, matches ?
                        searchBar("FULL") :
                        React.createElement(Tooltip, { title: "Search", placement: "right" },
                            React.createElement(Button, { type: "link", className: "no-padding no-margin", onClick: function () { return _this.setState({ isSearchExpanded: true }); } },
                                React.createElement(Icon, { className: "font-size-xl", component: function () { return React.createElement(FontAwesomeIcon, { icon: faSearchSolid }); } })))),
                    suffix &&
                        React.createElement(React.Fragment, null,
                            React.createElement("span", { className: "margin-left-xs" }, suffix)));
            };
            //column configurations
            var columns = (onload && roles && permissions) ? [
                __assign(__assign({ title: LabelConfigs.USER, key: "name", dataIndex: "", width: 180, minWidth: 180, ellipsis: true }, _this.searchFilterProps("", LabelConfigs.USER, "name", function (item) { return AvatarUtils.getAvatarDetails(item).name; })), { render: function (value, record) {
                        var name = AvatarUtils.getAvatarDetails(record).name;
                        return editUserPermission && onView && (adminOrSuperAdmin || record.role.name !== "Admin") ?
                            React.createElement("span", { onClick: function () {
                                    onView(record);
                                    try {
                                        AmplitudeEventsUtils.userListOnclickUsername();
                                    }
                                    catch (e) {
                                        console.error(e);
                                    }
                                }, className: "color-blue-5 cursor-pointer" },
                                React.createElement(Tooltip, { placement: "bottomLeft", title: name },
                                    React.createElement("b", null, name))) :
                            name;
                    } }),
                __assign({ title: LabelConfigs.USERNAME, key: "userName", dataIndex: "userName", width: 180, minWidth: 180, ellipsis: true }, _this.searchFilterProps("userName", LabelConfigs.USERNAME, "userName")),
                {
                    title: LabelConfigs.ROLE,
                    key: "role",
                    dataIndex: "role.name",
                    width: 120,
                    minWidth: 120,
                    ellipsis: true,
                    onClearFilter: function () {
                        var searchFilterKeys = _this.state.searchFilterKeys;
                        var newSearchFilterKeys = __assign({}, searchFilterKeys);
                        delete newSearchFilterKeys["role"];
                        _this.getUserData(__assign(__assign({}, _this.state.pagination), { current: initialPagination.current }), newSearchFilterKeys);
                        _this.setState({ searchFilterKeys: newSearchFilterKeys });
                    },
                    render: changeRolePermission ?
                        function (name, record) {
                            return record.id === onload.user.id || (name === "Admin" && !adminOrSuperAdmin) ?
                                React.createElement(Tooltip, { title: name }, name) :
                                React.createElement(PopoverSelectView, { onSelect: function (data) {
                                        _this.updateUserRole(record, data);
                                        AmplitudeEventsUtils.userListRoleChange(name, data.value);
                                    }, selectedData: { key: record.role.id, value: record.role.name }, data: (adminOrSuperAdmin ? roles : roles.filter(function (role) { return role.name !== "Admin"; })).map(function (role) { return ({ key: role.id, value: role.name, label: role.name }); }) },
                                    React.createElement(Button, { type: "link", style: { height: "0px", maxWidth: "85%" }, className: "no-padding no-margin" },
                                        React.createElement("div", { style: { display: "flex" } },
                                            " ",
                                            React.createElement("div", { className: "trim-overflown-text" }, name),
                                            React.createElement("span", { className: "padding-left-xs" }),
                                            React.createElement("div", null,
                                                React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faAngleDown }); } })))));
                        } :
                        undefined,
                    filters: roles.map(function (role) { return ({ text: role.name, value: role.id.toString() }); }),
                    filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
                    filterDropdown: function (_a) {
                        var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                        return (React.createElement("div", null,
                            React.createElement("div", { className: "padding-xs", style: { maxHeight: "300px", overflowY: "auto" } },
                                React.createElement(Checkbox.Group, { value: selectedKeys, onChange: function (values) {
                                        setSelectedKeys(values);
                                    } }, roles.map(function (role) {
                                    return React.createElement(React.Fragment, null,
                                        React.createElement(Checkbox, { className: "padding-bottom-xs", key: role.id, value: role.id }, role.name),
                                        React.createElement("br", null));
                                }))),
                            React.createElement(Divider, { type: "horizontal", className: "no-margin" }),
                            React.createElement(Row, { className: "padding-xs" },
                                React.createElement(Col, { span: 16 },
                                    React.createElement(Button, { type: "link", onClick: function () {
                                            var searchFilterKeys = _this.state.searchFilterKeys;
                                            var newSearchFilterKeys = __assign({}, searchFilterKeys);
                                            delete newSearchFilterKeys["role"];
                                            _this.getUserData(__assign(__assign({}, _this.state.pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                            clearFilters();
                                            _this.setState({ searchFilterKeys: newSearchFilterKeys });
                                        } },
                                        React.createElement(FontAwesomeIcon, { icon: faUndo }),
                                        React.createElement("span", { className: "margin-left-xs" }),
                                        React.createElement("b", null, "Revert to default"))),
                                React.createElement(Col, { span: 8, style: { textAlign: "right" } },
                                    React.createElement(Button, { type: "primary", onClick: function () {
                                            var searchFilterKeys = _this.state.searchFilterKeys;
                                            var newSearchFilterKeys = __assign(__assign({}, searchFilterKeys), { role: selectedKeys });
                                            _this.getUserData(__assign(__assign({}, _this.state.pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                            confirm();
                                            _this.setState({ searchFilterKeys: newSearchFilterKeys });
                                            var selectedStatusAnalytics = roles.filter(function (e) { return selectedKeys.includes(e.id); });
                                            AmplitudeEventsUtils.userListFilter(LabelConfigs.ROLE, selectedStatusAnalytics.map(function (e) { return e.name; }));
                                        } }, "Apply")))));
                    }
                },
                {
                    title: LabelConfigs.STATUS,
                    key: "status",
                    width: 120,
                    minWidth: 120,
                    dataIndex: "status.name",
                    render: editUserPermission ?
                        function (name, record) {
                            return record.id === onload.user.id || (record.role.name === "Admin" && !adminOrSuperAdmin) ?
                                React.createElement(Tooltip, { title: name }, name) :
                                React.createElement(Dropdown, { trigger: ["click"], overlay: React.createElement(Menu, { onClick: function (menuItem) {
                                            _this.updateUserStatus(record, parseInt(menuItem.key));
                                            AmplitudeEventsUtils.userListStatusChange('single', name, statusToAction(parseInt(menuItem.key)));
                                        } }, onload.userStatus.filter(function (currentStatus) { return !__spreadArray([record.status.id, UserStatusEnums.LOCKED], editUserPermission ? [] : [UserStatusEnums.DELETED], true).includes(currentStatus.id); }).map(function (status) {
                                        return React.createElement(Menu.Item, { key: status.id }, statusToAction(status.id));
                                    })) },
                                    React.createElement(Button, { type: 'link', className: "no-padding no-margin" },
                                        React.createElement("div", { style: { marginTop: '-15px' } },
                                            name,
                                            " ",
                                            React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faAngleDown }); } }))));
                        } :
                        undefined,
                    onClearFilter: function () {
                        var searchFilterKeys = _this.state.searchFilterKeys;
                        var newSearchFilterKeys = __assign({}, searchFilterKeys);
                        delete newSearchFilterKeys["role"];
                        _this.getUserData(__assign(__assign({}, _this.state.pagination), { current: initialPagination.current }), newSearchFilterKeys);
                        _this.setState({ searchFilterKeys: newSearchFilterKeys });
                    },
                    filterIcon: React.createElement(Icon, { component: function () { return React.createElement(FontAwesomeIcon, { icon: faFilter }); } }),
                    filters: onload.userStatus.map(function (status) { return ({ text: status.name, value: status.id.toString() }); }),
                    filterDropdown: function (_a) {
                        var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
                        return (React.createElement("div", null,
                            React.createElement("div", { className: "padding-xs" },
                                React.createElement(Checkbox.Group, { value: selectedKeys, onChange: function (values) {
                                        setSelectedKeys(values);
                                    } }, onload.userStatus.filter(function (status) { return status.id !== 3; }).map(function (status) {
                                    return React.createElement(React.Fragment, null,
                                        React.createElement(Checkbox, { className: "padding-bottom-xs", key: status.id, value: status.id }, status.name),
                                        React.createElement("br", null));
                                }))),
                            React.createElement(Divider, { type: "horizontal", className: "no-margin" }),
                            React.createElement(Row, { className: "padding-xs" },
                                React.createElement(Col, { span: 16 },
                                    React.createElement(Button, { type: "link", onClick: function () {
                                            var searchFilterKeys = _this.state.searchFilterKeys;
                                            var newSearchFilterKeys = __assign({}, searchFilterKeys);
                                            delete newSearchFilterKeys["status"];
                                            _this.getUserData(__assign(__assign({}, _this.state.pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                            clearFilters();
                                            _this.setState({ searchFilterKeys: newSearchFilterKeys });
                                        } },
                                        React.createElement(FontAwesomeIcon, { icon: faUndo }),
                                        React.createElement("span", { className: "margin-left-xs" }),
                                        React.createElement("b", null, "Revert to default"))),
                                React.createElement(Col, { span: 8, style: { textAlign: "right" } },
                                    React.createElement(Button, { type: "primary", onClick: function () {
                                            var searchFilterKeys = _this.state.searchFilterKeys;
                                            var newSearchFilterKeys = __assign(__assign({}, searchFilterKeys), { status: selectedKeys });
                                            _this.getUserData(__assign(__assign({}, _this.state.pagination), { current: initialPagination.current }), newSearchFilterKeys);
                                            confirm();
                                            _this.setState({ searchFilterKeys: newSearchFilterKeys });
                                            var selectedStatusAnalytics = onload.userStatus.filter(function (e) { return selectedKeys.includes(e.id); });
                                            AmplitudeEventsUtils.userListFilter(LabelConfigs.STATUS, selectedStatusAnalytics.map(function (e) { return e.name; }));
                                        } }, "Apply")))));
                    }
                },
                {
                    title: LabelConfigs.LAST_LOGIN,
                    key: "accessedOn",
                    dataIndex: "accessedOn",
                    width: 180,
                    minWidth: 180,
                    downloadRender: function (accessedOn) { return accessedOn ? moment(accessedOn).format(CalenderConfigs.DOWNLOAD_FORMATE) : ""; },
                    render: function (accessedOn) {
                        return React.createElement("span", null,
                            React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: moment(accessedOn).calendar() }, moment(accessedOn).calendar()));
                    },
                    ellipsis: true,
                },
                __assign(__assign({ title: LabelConfigs.EMAIL, key: "email", dataIndex: "email", width: 180, minWidth: 180 }, _this.searchFilterProps("email", LabelConfigs.EMAIL, "email")), { render: function (email) {
                        var wordsToHighLight = undefined;
                        var currentFilter = _this.state.searchFilterKeys.email;
                        if (currentFilter)
                            wordsToHighLight = Array.isArray(currentFilter) ? currentFilter : [currentFilter];
                        return email && wordsToHighLight ?
                            React.createElement(Highlighter, { highlightStyle: { backgroundColor: 'yellow', padding: 0 }, searchWords: wordsToHighLight, autoEscape: true, textToHighlight: email }) :
                            React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: email },
                                React.createElement("a", { style: { color: "inherit" }, href: "mailto:".concat(email) }, email));
                    }, ellipsis: true }),
                {
                    title: LabelConfigs.WORK_PHONE,
                    key: "phone",
                    dataIndex: "phone",
                    width: 120,
                    minWidth: 120,
                    ellipsis: true,
                    render: function (phone) {
                        if (phone) {
                            var internationalPhoneNumber = (phone.code ? "+ ".concat(phone.code, " ") : "") + (phone.number || "") + (phone.extension ? "x".concat(phone.extension, " ") : "");
                            var rfc3966PhoneNumber = "tel:".concat(internationalPhoneNumber);
                            var wordsToHighLight = undefined, currentFilter = _this.state.searchFilterKeys["phone"];
                            if (currentFilter)
                                wordsToHighLight = Array.isArray(currentFilter) ? currentFilter : [currentFilter];
                            return wordsToHighLight ?
                                React.createElement(Highlighter, { highlightStyle: { backgroundColor: 'yellow', padding: 0 }, searchWords: wordsToHighLight, autoEscape: true, textToHighlight: internationalPhoneNumber }) :
                                React.createElement("span", null,
                                    React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: internationalPhoneNumber },
                                        React.createElement("a", { style: { color: "inherit" }, href: rfc3966PhoneNumber }, internationalPhoneNumber)));
                        }
                        return undefined;
                    }
                },
                {
                    title: LabelConfigs.USERS_TIME_ZONE,
                    render: function (timezone) {
                        return timezone &&
                            React.createElement("span", null,
                                React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: timezone.name }, timezone.name));
                    },
                    key: "timezone",
                    dataIndex: "timezone",
                    width: 160,
                    minWidth: 160,
                    ellipsis: true,
                },
                {
                    title: LabelConfigs.ACCOUNT_CREATED,
                    key: "createdOn",
                    dataIndex: "createdOn",
                    width: 180,
                    minWidth: 180,
                    downloadRender: function (createdOn) { return createdOn ? moment(createdOn).format(CalenderConfigs.DOWNLOAD_FORMATE) : ""; },
                    render: function (createdOn) {
                        return React.createElement("span", null,
                            React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: moment(createdOn).calendar() }, moment(createdOn).calendar()));
                    },
                    ellipsis: true,
                },
                {
                    title: LabelConfigs.LAST_MODIFIED,
                    key: "updatedOn",
                    dataIndex: "updatedOn",
                    width: 180,
                    minWidth: 180,
                    downloadRender: function (updatedOn) { return updatedOn ? moment(updatedOn).format(CalenderConfigs.DOWNLOAD_FORMATE) : ""; },
                    render: function (updatedOn) {
                        return React.createElement("span", null,
                            React.createElement(Tooltip, { style: { fontSize: "10px" }, placement: "bottomLeft", title: moment(updatedOn).calendar() }, moment(updatedOn).calendar()));
                    },
                    ellipsis: true,
                },
            ] : [];
            /*if(onload?.financialInstitution?.type?.id === 4 && authentication.selectedBrand.id === onload?.financialInstitution?.id){
                columns.push( {
                    title: LabelConfigs.SUPPORT_PARTNER,
                    key: "supportPartner",
                    dataIndex: "supportPartner.name",
                    width: 180,
                    minWidth: 180,
                    ellipsis: true
                },)
            }*/
            //filtered users
            var filteredData = filter ? (users || []).filter(filter) : users;
            //quick actions
            var quickActions = __spreadArray(__spreadArray(__spreadArray([], selectedRowStatus.includes(UserStatusEnums.ACTIVE) ? [] : [{ id: UserStatusEnums.ACTIVE, name: "Activate user(s)" }], true), selectedRowStatus.includes(UserStatusEnums.SUSPENDED) ? [] : [{ id: UserStatusEnums.SUSPENDED, name: "Suspend user(s)" }], true), editUserPermission ? [{ id: UserStatusEnums.DELETED, name: "Delete user(s)" }] : [], true).map(function (status) { return ({
                name: status.name,
                key: status.id.toString(),
                onClick: function (records) {
                    if ((status === null || status === void 0 ? void 0 : status.id) === 3) {
                        Modal.confirm({
                            width: "450px",
                            keyboard: false,
                            title: React.createElement(React.Fragment, null,
                                React.createElement(Typography.Text, { className: "color-blue-5", style: { fontSize: '28px' }, strong: true },
                                    "Are you sure you want to delete all ",
                                    records.length,
                                    " users?"),
                                React.createElement("br", null),
                                React.createElement("br", null),
                                React.createElement(Typography.Text, { className: "font-size-lg", type: "secondary" }, "This action cannot be undone."),
                                React.createElement("br", null)),
                            icon: null,
                            cancelButtonProps: { type: "danger" },
                            okButtonProps: { type: "primary" },
                            cancelText: "Delete",
                            okText: "Cancel",
                            onOk: function () { },
                            onCancel: function () { return _this.updateUsersStatus(records, status); },
                        });
                    }
                    else {
                        _this.updateUsersStatus(records, status);
                    }
                    AmplitudeEventsUtils.userListStatusChange('bulk', records.map(function (e) { return e.status.name; }), status.name);
                }
            }); });
            var formattedColumns = TableUtils.formatColumns(columns, savedColumnMap);
            var extraView = function (matches) {
                return React.createElement(React.Fragment, null,
                    matches ?
                        React.createElement(Button, { type: "link", className: "no-margin no-padding", onClick: function () { return _this.onExport(columns); } },
                            React.createElement(Icon, { className: "font-size-lg", component: function () { return React.createElement(FontAwesomeIcon, { icon: faDownload }); } }),
                            React.createElement("span", { className: "margin-left-xs" }),
                            "Export") :
                        React.createElement(Tooltip, { title: "Export", placement: "left" },
                            React.createElement(Button, { type: "link", className: "no-margin no-padding", onClick: function () { return _this.onExport(columns); } },
                                React.createElement(Icon, { className: "font-size-xl", component: function () { return React.createElement(FontAwesomeIcon, { icon: faDownload }); } }))),
                    extra &&
                        React.createElement(React.Fragment, null,
                            React.createElement("span", { className: "margin-left-xs" }),
                            extra));
            };
            return (onload && roles && tablePreferenceData && permissions ?
                React.createElement(MediaQuery, { minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD }, function (matches) {
                    var _a;
                    return React.createElement(TableView, { showClearFilter: true, onClearAllFilter: function (isLocale) {
                            if (isLocale) {
                                _this.onSearch("");
                                _this.inputGlobalSearchRef.state.value = "";
                            }
                            _this.getUserData(__assign(__assign({}, _this.state.pagination), { current: initialPagination.current }), {});
                            _this.setState({ searchFilterKeys: {} });
                        }, locale: { emptyText: "We can't find any users." }, prefix: prefix, suffix: suffixView(matches), header: header, defaultColumnKeys: columns.map(function (column) { return (column.key || "").toString(); }), quickActions: editUserPermission ? quickActions : undefined, onRowSelect: function (ids) {
                            var status = [];
                            filteredData === null || filteredData === void 0 ? void 0 : filteredData.filter(function (user) { return ids.includes(user.id.toString()); }).forEach(function (data) {
                                var currentStatusId = data.status.id;
                                if (!status.includes(currentStatusId)) {
                                    status.push(currentStatusId);
                                }
                            });
                            _this.setState({
                                selectedRowStatus: status
                            });
                        }, fixedColumns: ["name"], loading: !users, data: filteredData || [], getRowKey: function (users) { return users.id.toString(); }, extra: extraView(matches), title: isSearchExpanded &&
                            searchBar("COMPACT"), onPreferenceChanges: _this.onTablePreferenceChanges, onDensityChange: function (size) { return AmplitudeEventsUtils.userListCustomize('CHANGE DENSITY', size); }, onOrderChange: function (column, initialPosition, newPosition) { return AmplitudeEventsUtils.userListCustomize('CHANGE COLUMN ORDER', { column: column, initialPosition: initialPosition, newPosition: newPosition }); }, onToggle: function (action, key) { return AmplitudeEventsUtils.userListCustomize(action === 'Add' ? 'ADD COLUMN' : 'REMOVE COLUMN', key); }, onResize: function (column, width) { return AmplitudeEventsUtils.userListCustomize('CHANGE COLUMN WIDTH', { column: column, width: width }); }, getRowDisabledKey: function (data) { return data.id === onload.user.id || (!adminOrSuperAdmin && data.role.name === "Admin"); }, onChange: function (newPagination, newFilters, newSorter) {
                            var _a, _b;
                            if (newPagination && (newPagination.current !== pagination.current || newPagination.pageSize !== pagination.pageSize)) {
                                _this.getUserData(newPagination, searchFilterKeys);
                            }
                            if (newSorter) {
                                if (((_a = _this.state.previousSort) === null || _a === void 0 ? void 0 : _a.field) === newSorter.field ?
                                    ((_b = _this.state.previousSort) === null || _b === void 0 ? void 0 : _b.order) !== newSorter.order ? true : false : true) {
                                    _this.setState({
                                        previousSort: newSorter
                                    }, function () {
                                        var _a;
                                        if ((_a = _this.state.previousSort) === null || _a === void 0 ? void 0 : _a.column)
                                            AmplitudeEventsUtils.userListSort(_this.state.previousSort.column.key, _this.state.previousSort.order);
                                    });
                                }
                            }
                            if (newFilters)
                                _this.onFilterAmplitudeEvents(newFilters);
                        }, columns: formattedColumns === null || formattedColumns === void 0 ? void 0 : formattedColumns.allColumns, rowDensity: tablePreferenceData === null || tablePreferenceData === void 0 ? void 0 : tablePreferenceData.density, selectedColumnKeys: ((_a = formattedColumns === null || formattedColumns === void 0 ? void 0 : formattedColumns.visibleColumns) === null || _a === void 0 ? void 0 : _a.length) > 0 ? formattedColumns === null || formattedColumns === void 0 ? void 0 : formattedColumns.visibleColumns : undefined, pagination: pagination });
                }) :
                React.createElement(Row, { type: "flex", justify: "center", align: "middle", style: { height: "80vh" } },
                    React.createElement(Col, null,
                        React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) }))));
        };
        return _this;
    }
    return UserList;
}(React.Component));
export default UserList;
//# sourceMappingURL=index.js.map